import { useEffect, useState } from 'react'
import { Routes, Route, useLocation } from "react-router-dom";
import Login from '../container/Login';
import Dashboard from '../container/DashboardScreen';
import AppVersion from '../component/AppVersion';
import NotFound from '../NotFound';
import { APP_URLS } from '../utils/constant';

import ResetPassword from '../container/Login/Reset';
import CreatePasswordContainer from '../container/ProfileScreen/CreateChangePassword';
import VehicleBodyShopScreen from '../container/Vehicles/VehicleBodyShopScreen';
import CreateVehicleBodyShop from '../container/Vehicles/VehicleBodyShopScreen/CreateVehicleBodyShop';

import RentersRentersInfoScreen from '../container/Renters/RentersRentersInfoScreen';
import CreateRentersRentersInfo from '../container/Renters/RentersRentersInfoScreen/CreateRentersRentersInfo';
import RentersRevenueAgreementsScreen from '../container/Renters/RentersRevenueAgreementsScreen';
import CreateRentersRevenueAgreements from '../container/Renters/RentersRevenueAgreementsScreen/CreateRentersRevenueAgreements';
import RentersNonRevenueAgreementsScreen from '../container/Renters/RentersNonRevenueAgreementsScreen';
import CreateRentersNonRevenueAgreements from '../container/Renters/RentersNonRevenueAgreementsScreen/CreateRentersNonRevenueAgreements';
import RentersRegisteredRentersScreen from '../container/Renters/RentersRegisteredRentersScreen';
import RentersRegisteredRentersViewScreen from '../container/Renters/RentersRegisteredRentersScreen/ViewRentersRegisteredRenters';
import CreateRentersRegisteredRenters from '../container/Renters/RentersRegisteredRentersScreen/CreateRentersRegisteredRenters';
import RentersLogInteractionsScreen from '../container/Renters/RentersLogInteractionsScreen';
import CreateRentersLogInteractions from '../container/Renters/RentersLogInteractionsScreen/CreateRentersLogInteractions';
import ReservationsCRXRezpowerReservationsScreen from '../container/Reservations/ReservationsCRXRezpowerReservationsScreen';
import CreateReservationsCRXRezpowerReservations from '../container/Reservations/ReservationsCRXRezpowerReservationsScreen/CreateReservationsCRXRezpowerReservations';
import ReservationsQuotesScreen from '../container/Reservations/ReservationsQuotesScreen';
import ReservationsBidsScreen from '../container/Reservations/ReservationsBidsScreen';
import ReservationsTransactionsScreen from '../container/Reservations/ReservationsTransactionsScreen';
import CalendarScreen from '../container/TaskAssignment/CalendarScreen';
import RecurringToDoListScreen from '../container/TaskAssignment/RecurringToDoListScreen';
import TaskManagementSystemScreen from '../container/TaskAssignment/TaskManagementSystemScreen';
import CorporateMeetingsScreen from '../container/Admin/CorporateMeetingsScreen';
import LeaveApplicationsScreen from '../container/Admin/LeaveApplicationsScreen';
import ArScreen from '../container/Financial/ArScreen';
import InvoicingScreen from '../container/Financial/InvoicingScreen';
import MiscUploadsScreen from '../container/Financial/MiscUploadsScreen';
import RentalChecklistScreen from '../container/Financial/RentalChecklistScreen';
import TimeAndBillingScreen from '../container/Financial/TimeAndBillingScreen';
import VendorsScreen from '../container/Financial/VendorsScreen';
import WholesaleBillOfSaleScreen from '../container/Financial/WholesaleBillOfSaleScreen';
import SendBulkEmailScreen from '../container/Communication/SendBulkEmailScreen';
import SendBulkSMSScreen from '../container/Communication/SendBulkSMSScreen';
import SendNotificationsScreen from '../container/Communication/SendNotificationsScreen';
import StaffScreen from '../container/Communication/StaffScreen';
import CareersScreen from '../container/Operations/CareersScreen';
import FormsScreen from '../container/Operations/FormsScreen';
import NewslettersScreen from '../container/Operations/NewslettersScreen';
import StaffManagementScreen from '../container/Operations/StaffManagementScreen';
import BlogsScreen from '../container/Website/BlogsScreen';
import PromotionScreen from '../container/Website/PromotionScreen';
import TrafficLogsScreen from '../container/Website/TrafficLogsScreen';

import MaintenanceCategorysScreen from '../container/Maintenance/MaintenanceCategorysScreen';
import MaintenanceRecordsScreen from '../container/Maintenance/MaintenanceRecordsScreen';
import ClaimsCostCategoryScreen from '../container/ClaimsManager/ClaimsCostCategoryScreen';
import ClaimsScreen from '../container/ClaimsManager/ClaimsScreen';
import BodyRepairShopsScreen from '../container/CounterManager/BodyRepairShopsScreen';
import BroadcastMessagesScreen from '../container/CounterManager/BroadcastMessagesScreen';
import NonRevMovementScreen from '../container/CounterManager/NonRevMovementScreen';

import FaultValuesScreen from '../container/IncidentScreen/FaultValuesScreen';
import IncidentReportScreen from '../container/IncidentScreen/IncidentReportScreen';

import CalendarPickupScreen from '../container/CalendarScreen/CalendarPickupScreen';
import CalendarDropoffScreen from '../container/CalendarScreen/CalendarDropoffScreen';

//new path
import ReservationsReservationsRoutes from './routes/Reservations/reservationsReservationsRoutes';
import ReservationsRoutes from './routes/Reservations/reservationsRoutes';
import LocationRoutes from './routes/locationRoutes';
import AffiliateRoutes from './routes/Affiliate/affiliateRoutes';
import AffiliateDashboardRoutes from './routes/Affiliate/affiliateDashboardRoutes';
import AffiliateReportRoutes from './routes/Affiliate/affiliateReportRoutes';
import AffiliateInvoiceRoutes from './routes/Affiliate/affiliateInvoiceRoutes';
import ReservationsDetailReportRoutes from './routes/Reservations/reservationsDetailReportRoutes';
import ReservationsDailyManifestReportRoutes from './routes/Reservations/reservationsDailyManifestReportRoutes';
import ReservationsBookingsbyLocationReportRoutes from './routes/Reservations/reservationsBookingsbyLocationReportRoutes';
import ReservationsByLocationAndNetworkRoutes from './routes/Reservations/reservationsByLocationAndNetworkRoutes';
import RevenueByNetworkRoutes from './routes/Reservations/revenueByNetworkRoutes';
import ReservationsPrepaidBookingsReportRoutes from './routes/Reservations/reservationsPrepaidBookingsReportRoutes';
import HolidaysRoutes from './routes/holidaysRoutes';
import SettingsSettingWeekendsRoutes from './routes/Settings/settingsSettingWeekendsRoutes';
import SettingsPaynowDiscountsRoutes from './routes/Settings/settingsPaynowDiscountsRoutes';
import SettingsPaynowOptionsRoutes from './routes/Settings/settingsPaynowOptionsRoutes';
import VehicleCategoryRoutes from './routes/Vehicles/vehicleCategoryRoutes';
import VehicleMakeRoutes from './routes/Vehicles/vehicleMakeRoutes';
import VehicleModelRoutes from './routes/Vehicles/vehicleModelRoutes';
import VehicleTrimRoutes from './routes/Vehicles/vehicleTrimRoutes';
import VehicleTransmissionTypeRoutes from './routes/Vehicles/vehicleTransmissionTypeRoutes';
import VehicleAcTypeRoutes from './routes/Vehicles/vehicleAcTypeRoutes';
import VehicleStereoTypeRoutes from './routes/Vehicles/vehicleStereoTypeRoutes';
import VehicleOperationRoutes from './routes/Vehicles/vehicleOperationsRoutes';
import RateAdminRateCodeRoutes from './routes/RateAdmin/rateAdminRateCodeRoutes';
import RateAdminRatePlanRoutes from './routes/RateAdmin/rateAdminRatePlanRoutes';
import RateAdminRateTypesRoutes from './routes/RateAdmin/rateAdminRateTypesRoutes';
import RateAdminLorAdjustmentsRoutes from './routes/RateAdmin/rateAdminLorAdjustmentsRoutes';
import RateAdminRatesRoutes from './routes/RateAdmin/rateAdminRatesRoutes';
import RateAdminExtraProductCategoryRoutes from './routes/RateAdmin/rateAdminExtraProductCategoryRoutes';
import RateAdminExtraProductChargeRoutes from './routes/RateAdmin/rateAdminExtraProductChargeRoute';
import RateAdminNetworksRoutes from './routes/RateAdmin/rateAdminNetworksRoutes';
import RateAdminBlackoutsRoutes from './routes/RateAdmin/rateAdminBlackoutsRoutes';
import RateAdminRateMirrorsRoutes from './routes/RateAdmin/rateAdminRateMirrorsRoutes';
import RateAdminAdvanceRateRoutes from './routes/RateAdmin/rateAdminAdvanceRateRoutes';
import VehicleVehicleStatusRoutes from './routes/Vehicles/vehicleVehicleStatusRoutes';
import VehicleDealershipsRoutes from './routes/Vehicles/vehicleDealershipsRoutes';
import VehicleDealershipVehicleDealRoutes from './routes/Vehicles/vehicleDealershipVehicleDealRoutes';
import UsersRoutes from './routes/System/UsersRoutes';
import RoleRoutes from './routes/System/RoleRoutes';
import CompaniesRoutes from './routes/System/CompaniesRoutes';
import RentersVehicleInquiryRoutes from './routes/Renters/RentersVehicleInquiryRoutes';



export default function Router(props) {
  useLocation(); // re-read localStorage permissions on every navigation
  const access = JSON.parse(localStorage.getItem('menuAccess'));
  const Update = () => {
    props.switchHeader();
  }
  return (
    <Routes>
      <Route exact={true} path="/" element={<Login callBack={Update} />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/app-version" element={<AppVersion />} />
      <Route path={APP_URLS.CHANGEPASSWORD} element={<CreatePasswordContainer />} />

      {LocationRoutes(access?.locationsMenu)}
      
      {AffiliateRoutes(access?.affiliateMenu)}
      {AffiliateDashboardRoutes(access?.affiliateDashboardMenu)}
      {AffiliateReportRoutes(access?.affiliateReportMenu)}
      {AffiliateInvoiceRoutes(access?.affiliateInvoiceMenu)}
      
      {VehicleCategoryRoutes(access?.vehicleCategoryMenu)}
      {VehicleMakeRoutes(access?.makeMenu)}
      {VehicleModelRoutes(access?.modelMenu)}
      {VehicleTrimRoutes(access?.trimMenu)}
      {VehicleTransmissionTypeRoutes(access?.transmissionTypeMenu)}
      {VehicleAcTypeRoutes(access?.acTypeMenu)}
      {VehicleStereoTypeRoutes(access?.stereoTypeMenu)}
      {VehicleOperationRoutes(access?.vehiclesMenu)}
      {VehicleVehicleStatusRoutes(access?.vehicleStatusMenu)}
      {VehicleDealershipsRoutes(access?.dealershipsMenu ?? { view: true, create: true, edit: true })}
      {VehicleDealershipVehicleDealRoutes(access?.dealershipVehicleDealsMenu)}

      <Route path={APP_URLS.VEHICLE_BODYSHOP.HOME} element={<VehicleBodyShopScreen />} />
      <Route path={APP_URLS.VEHICLE_BODYSHOP.CREATE} element={<CreateVehicleBodyShop />} />
      <Route path={APP_URLS.VEHICLE_BODYSHOP.EDIT} element={<CreateVehicleBodyShop isEdit={true} />} />

      {RateAdminRateCodeRoutes(access?.rateCodeMenu)}
      {RateAdminRatePlanRoutes(access?.ratePlansMenu)}
      {RateAdminRateTypesRoutes(access?.rateTypesMenu)}
      {RateAdminLorAdjustmentsRoutes(access?.lorAdjustmentsMenu)}
      {RateAdminRatesRoutes(access?.ratesMenu)}
      {RateAdminExtraProductCategoryRoutes(access?.extraProductCategoryMenu)}
      {RateAdminExtraProductChargeRoutes(access?.extraProductChargeMenu)}
      {RateAdminNetworksRoutes(access?.networksMenu)}
      {RateAdminBlackoutsRoutes(access?.blackoutsMenu)}
      {RateAdminRateMirrorsRoutes(access?.rateMirrorMenu)}
      {RateAdminAdvanceRateRoutes(access?.advanceRateMenu)}

      {HolidaysRoutes(access?.holidaysMenu)}
      {SettingsSettingWeekendsRoutes(access?.daysOfWeekMenu)}
      {SettingsPaynowDiscountsRoutes(access?.payNowDiscountMenu)}
      {SettingsPaynowOptionsRoutes(access?.payNowOptionMenu)}

      <Route path={APP_URLS.RENTERS_RENTERSINFO.HOME} element={<RentersRentersInfoScreen />} />
      <Route path={APP_URLS.RENTERS_RENTERSINFO.CREATE} element={<CreateRentersRentersInfo />} />
      <Route path={APP_URLS.RENTERS_RENTERSINFO.EDIT} element={<CreateRentersRentersInfo isEdit={true} />} />

      <Route path={APP_URLS.RENTERS_REVENUEAGREEMENTS.HOME} element={<RentersRevenueAgreementsScreen />} />
      <Route path={APP_URLS.RENTERS_REVENUEAGREEMENTS.CREATE} element={<CreateRentersRevenueAgreements />} />
      <Route path={APP_URLS.RENTERS_REVENUEAGREEMENTS.EDIT} element={<CreateRentersRevenueAgreements isEdit={true} />} />

      <Route path={APP_URLS.RENTERS_NONREVENUEAGREEMENTS.HOME} element={<RentersNonRevenueAgreementsScreen />} />
      <Route path={APP_URLS.RENTERS_NONREVENUEAGREEMENTS.CREATE} element={<CreateRentersNonRevenueAgreements />} />
      <Route path={APP_URLS.RENTERS_NONREVENUEAGREEMENTS.EDIT} element={<CreateRentersNonRevenueAgreements isEdit={true} />} />

      {RentersVehicleInquiryRoutes(access?.vehicleInquiriesMenu)}

      <Route path={APP_URLS.RENTERS_REGISTEREDRENTERS.HOME} element={<RentersRegisteredRentersScreen />} />
      <Route path={APP_URLS.RENTERS_REGISTEREDRENTERS.CREATE} element={<CreateRentersRegisteredRenters />} />
      <Route path={APP_URLS.RENTERS_REGISTEREDRENTERS.VIEW} element={<RentersRegisteredRentersViewScreen />} />
      <Route path={APP_URLS.RENTERS_REGISTEREDRENTERS.EDIT} element={<CreateRentersRegisteredRenters isEdit={true} />} />

      <Route path={APP_URLS.RENTERS_LOGINTERACTIONS.HOME} element={<RentersLogInteractionsScreen />} />
      <Route path={APP_URLS.RENTERS_LOGINTERACTIONS.CREATE} element={<CreateRentersLogInteractions />} />
      <Route path={APP_URLS.RENTERS_LOGINTERACTIONS.EDIT} element={<CreateRentersLogInteractions isEdit={true} />} />

      {ReservationsRoutes(access?.reservationsMenu3)}
      {ReservationsReservationsRoutes(access?.reservationsMenu2)}
      {ReservationsDetailReportRoutes(access?.reservationsDetailReportNewMenu)}
      {ReservationsDailyManifestReportRoutes(access?.dailyManifestReportNewMenu)}
      {ReservationsBookingsbyLocationReportRoutes(access?.bookingsByLocationReportNewMenu)}
      {ReservationsByLocationAndNetworkRoutes(access?.reservationsByLocationAndNetworkMenu)}
      {RevenueByNetworkRoutes(access?.revenueByNetworkMenu)}
      {ReservationsPrepaidBookingsReportRoutes(access?.prepaidBookingsReportNewMenu)}
      {/* {ReservationsCRXRezpowerReservationsRoutes(access?.)} */}
      <Route path={APP_URLS.RESERVATIONS_CRXREZPOWERRESERVATIONS.HOME} element={<ReservationsCRXRezpowerReservationsScreen />} />
      <Route path={APP_URLS.RESERVATIONS_CRXREZPOWERRESERVATIONS.CREATE} element={<CreateReservationsCRXRezpowerReservations />} />
      <Route path={APP_URLS.RESERVATIONS_CRXREZPOWERRESERVATIONS.EDIT} element={<CreateReservationsCRXRezpowerReservations isEdit={true} />} />

      <Route path={APP_URLS.RESERVATIONS_QUOTES.HOME} element={<ReservationsQuotesScreen />} />

      <Route path={APP_URLS.RESERVATIONS_BIDS.HOME} element={<ReservationsBidsScreen />} />

      <Route path={APP_URLS.RESERVATIONS_TRANSACTIONS.HOME} element={<ReservationsTransactionsScreen />} />
      <Route path={APP_URLS.WEBSITE_BLOGS.HOME} element={<BlogsScreen />} />
      <Route path={APP_URLS.WEBSITE_PROMOTION.HOME} element={<PromotionScreen />} />
      <Route path={APP_URLS.WEBSITE_TRAFFIC_LOGS.HOME} element={<TrafficLogsScreen />} />

      <Route path={APP_URLS.OPERATIONS_CAREERS.HOME} element={<CareersScreen />} />
      {/* <Route path={APP_URLS.OPERATIONS_FORMS.HOME} element={<FormsScreen />} /> */}
      <Route path={APP_URLS.OPERATIONS_NEWSLETTERS.HOME} element={<NewslettersScreen />} />
      <Route path={APP_URLS.OPERATIONS_STAFF_MANAGEMENT.HOME} element={<StaffManagementScreen />} />

      <Route path={APP_URLS.TASK_ASSIGNMENT_CALENDAR.HOME} element={<CalendarScreen />} />

      <Route path={APP_URLS.TASK_ASSIGNMENT_RECURRING_TO_DO_LIST.HOME} element={<RecurringToDoListScreen />} />

      <Route path={APP_URLS.TASK_ASSIGNMENT_TASK_MANAGEMENT_SYSTEM.HOME} element={<TaskManagementSystemScreen />} />

      <Route path={APP_URLS.ADMIN_CORPORATE_MEETINGS.HOME} element={<CorporateMeetingsScreen />} />

      <Route path={APP_URLS.ADMIN_LEAVE_APPLICATIONS.HOME} element={<LeaveApplicationsScreen />} />

      <Route path={APP_URLS.FINANCIAL_A_R.HOME} element={<ArScreen />} />
      <Route path={APP_URLS.FINANCIAL_INVOICING.HOME} element={<InvoicingScreen />} />
      <Route path={APP_URLS.FINANCIAL_MISC_UPLOADS.HOME} element={<MiscUploadsScreen />} />
      <Route path={APP_URLS.FINANCIAL_RENTAL_CHECKLIST.HOME} element={<RentalChecklistScreen />} />
      <Route path={APP_URLS.FINANCIAL_TIME_BILLINGS.HOME} element={<TimeAndBillingScreen />} />
      <Route path={APP_URLS.FINANCIAL_VENDORS.HOME} element={<VendorsScreen />} />
      <Route path={APP_URLS.FINANCIAL_WHOLESALE_BILL_OF_SALE.HOME} element={<WholesaleBillOfSaleScreen />} />

      <Route path={APP_URLS.COMMUNICATION_SEND_BULK_EMAIL.HOME} element={<SendBulkEmailScreen />} />
      <Route path={APP_URLS.COMMUNICATION_SEND_BULK_SMS.HOME} element={<SendBulkSMSScreen />} />
      <Route path={APP_URLS.COMMUNICATION_SEND_NOTIFICATIONS.HOME} element={<SendNotificationsScreen />} />
      <Route path={APP_URLS.COMMUNICATION_STAFF.HOME} element={<StaffScreen />} />
      {/* <Route path={APP_URLS.FINANCIAL_A_R.HOME} element={<CalendarS />} /> */}


      <Route path={APP_URLS.INCIDENT_FAULT_VALUES.HOME} element={<FaultValuesScreen />} />
      <Route path={APP_URLS.INCIDENT_INCIDENT_REPORT.HOME} element={<IncidentReportScreen />} />

      <Route path={APP_URLS.MAINTENANCE_CATEGORYS.HOME} element={<MaintenanceCategorysScreen />} />
      <Route path={APP_URLS.MAINTENANCE_RECORDS.HOME} element={<MaintenanceRecordsScreen />} />

      <Route path={APP_URLS.CLAIMS_COST_CATEGORY.HOME} element={<ClaimsCostCategoryScreen />} />
      <Route path={APP_URLS.CAIMS.HOME} element={<ClaimsScreen />} />

      <Route path={APP_URLS.COUNTER_MANAGER_BODY_REPAIR_SHOPS.HOME} element={<BodyRepairShopsScreen />} />
      <Route path={APP_URLS.COUNTER_MANAGER_BROADCAST_MESSAGES.HOME} element={<BroadcastMessagesScreen />} />
      <Route path={APP_URLS.COUNTER_MANAGER_NON_REV_MOVEMENT.HOME} element={<NonRevMovementScreen />} />

      <Route path={APP_URLS.CALENDAR_CALENDAR_PICKUP.HOME} element={<CalendarPickupScreen />} />
      <Route path={APP_URLS.CALENDAR_CALENDAR_DROPOFF.HOME} element={<CalendarDropoffScreen />} />

        {UsersRoutes(access?.usersMenu)}
        {RoleRoutes(access?.rolesMenu)}
        {CompaniesRoutes(access?.companyMenu)}

        <Route path="*" element={<NotFound />} />
      </Routes>
    )
  }
